<template>
  <div class="attendance-container">
    <div class="attendance-content-outer">
      <div class="attendance-content-title">
        <p>Students Attendance</p>

        <!-- <div class="attendance-content-filter">
           <field :label="'Filter by'">
              <control :options="filterType" v-model="filter.filter_type" />
            </field>

            <field v-if="filter.filter_type == 'date'" :label="'Date Range'">
              <Datepicker v-model="filter.date_range" range :auto-apply="true" />
            </field>

            <field :label="''">
              <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="getData()" />
            </field>
        </div> -->
      </div>

      <div class="attendance-header-container">
        <div class="attendance-header">
          <!-- <p>{{ formatMode(studentAttendanceFilter.mode) }}</p> -->
          <p>{{ formattedMode }}</p>
          <p>{{ studentAttendanceData.percent_presence }} %</p>
          <!-- <p v-if="studentAttendanceFilter.mode === 'today'">{{ studentAttendanceData.total_student_presence }} / {{ studentAttendanceData.total_student }}</p> -->
          <p v-if="studentAttendanceFilter?.mode === 'today'">{{ studentAttendanceData.total_student_presence }} / {{ studentAttendanceData.total_student }}</p>
          <p>Students Present</p>
          <p v-if="filterParams.filter_type == 'today'">{{ formatDate(filterParams.start_date) }}</p>
          <!-- <p v-if="filterParams.filter_type == 'date'">{{ formatDate(filterParams.start_date, filterParams.end_date) }}</p> -->
        </div>

        <table class="attendance-details">
          <tr>
            <td>Tardy</td>
            <td>{{ studentAttendanceData.total_student_tardy }}</td>
            <td>{{ (studentAttendanceData.total_student_tardy > 1) ? 'Students' : 'Student' }}</td>
          </tr>
          <tr>
            <td>Sick</td>
            <td>{{ studentAttendanceData.total_student_sick }}</td>
            <td>{{ (studentAttendanceData.total_student_sick > 1) ? 'Students' : 'Student' }}</td>
          </tr>
          <tr>
            <td>Permission</td>
            <td>{{ studentAttendanceData.total_student_permission }}</td>
            <td>{{ (studentAttendanceData.total_student_permission > 1) ? 'Students' : 'Student' }}</td>
          </tr>
          <tr>
            <td>Absent</td>
            <td>{{ studentAttendanceData.total_student_absent }}</td>
            <td>{{ (studentAttendanceData.total_student_absent > 1) ? 'Students' : 'Student' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { useToast } from 'vue-toastification'
  import { useI18n } from 'vue-i18n'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import Datepicker from "@vuepic/vue-datepicker"
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'

  import { mdiNewspaperVariantOutline, mdiCommentTextMultipleOutline, mdiFileDownloadOutline, mdiFile } from '@mdi/js'

  import Icon from "@/components/Icon"
  import Field from '@/components/Field'
  import Control from '@/components/Control'
  import JbButton from '@/components/JbButton'

  export default {
    components: {
      Icon,
      Field,
      Control,
      JbButton,
      Datepicker
    },

    props: {
      filterTeacherAttendance: {type: Object, default: () => ({})},
      studentAttendanceFilter: {type: Object, default: () => ({})},
      studentAttendanceData: {type: Object, default: () => ({})},
      filterParams: {type: Object, default: () => ({})}
    },

    setup (props, { emit }) {
      const studentAttendanceFilter = computed(() => props.studentAttendanceFilter)

      const filter = reactive({
        filter_type: "today",
        start_date: "",
        end_date: "",
        date_range: []
      })
      const filterType = ref([
        {
          id: "today",
          label: "Today"
        },
        {
          id: "date",
          label: "Date Range"
        },
      ])

      dayjs.locale('en')

      const formatDate = (startDate, endDate = null) => {
        if (!startDate) return ''

        const start = dayjs(startDate)

        if (!endDate) {
          return start.format('dddd, D MMMM YYYY')
        }

        const end = dayjs(endDate)

        if (start.isSame(end, 'day')) {
          return start.format('dddd, D MMMM YYYY')
        }

        const sameYear = start.year() === end.year()
        const sameMonth = start.month() === end.month() && sameYear

        if (sameMonth) {
          return `${start.format('D')}-${end.format('D MMMM YYYY')}`
        }

        if (sameYear) {
          return `${start.format('D MMMM')} - ${end.format('D MMMM YYYY')}`
        }

        return `${start.format('D MMMM YYYY')} - ${end.format('D MMMM YYYY')}`
      }

      // const formatMode = (mode) => {
      //   const modeMap = {
      //     'single_day'    : formatDate(studentAttendanceFilter?.start_date),
      //     'date_range'    : formatDate(studentAttendanceFilter?.start_date, studentAttendanceFilter?.end_date),
      //     'month'         : 'Month',
      //     'academic_year' : 'Academic Year' + ' ' + studentAttendanceFilter?.academic_year,
      //     'today'         : 'Today',
      //   }

      //   return modeMap[mode] ?? mode ?? '-'
      // }

      const formattedMode = computed(() => {
        const filter = props.studentAttendanceFilter
        if (!filter || Object.keys(filter).length === 0) return ''

        const modeMap = {
          'single_day'    : formatDate(filter?.start_date),
          'date_range'    : formatDate(filter?.start_date, filter?.end_date),
          'month'         : 'Month',
          'academic_year' : 'Academic Year ' + (filter?.academic_year ?? ''),
          'today'         : 'Today',
        }

        return modeMap[filter?.mode] ?? formatDate(filter?.start_date) ?? '-'
      })


      return {
        studentAttendanceFilter,
        filter,
        filterType,
        formatDate,
        formattedMode,
      }
    }
  }
</script>

<style lang="scss">
  .attendance-container {
    .attendance-content-outer {
      width: 100%;
      height: auto;
      background-color: white;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
      padding: 20px;

      .attendance-header {
        width: 100%;
        position: relative;

        p {
          width: 100%;
          text-align: center;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;

          &:nth-child(2) {
            font-size: 40px;
            line-height: 60px;
            font-weight: 700;
            // color: rgb(0, 106, 255);
          }
        }
      }

      table.attendance-details {
        width: 100%;

        tr {
          td {
            font-size: 14px;
            line-height: 20px;
            padding: 8px 0;
            font-weight: 500;

            &:nth-child(1) {
              width: 100px;
            }

            &:nth-child(2) {
              text-align: right;
              padding-right: 8px;
              font-weight: 600;
            }

            &:nth-child(3) {
              width: 80px;
            }
          }

          &:nth-child(1) {
            td {
              color: orangered;
            }
          }

          &:nth-child(2) {
            td {
              color: blue;
            }
          }

          &:nth-child(3) {
            td {
              color: green;
            }
          }

          &:nth-child(4) {
            td {
              color: red;
            }
          }
        }
      }
    }
  }
</style>
